// components/Spinner.js
import React from "react";
export default function Spinner({ size = 16, className = "" }) {
  return (
    <svg
      className={`spinner ${className}`}
      width={size}
      height={size}
      viewBox="0 0 50 50"
      style={{ verticalAlign: "middle" }}
    >
      <circle
        className="path"
        cx="25"
        cy="25"
        r="20"
        fill="none"
        stroke="#4B5563"
        strokeWidth="5"
      />
    </svg>
  );
}